import { render, staticRenderFns } from "./ContainerErrorsPage.vue?vue&type=template&id=c928455a&"
import script from "./ContainerErrorsPage.vue?vue&type=script&lang=js&"
export * from "./ContainerErrorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c928455a')) {
      api.createRecord('c928455a', component.options)
    } else {
      api.reload('c928455a', component.options)
    }
    module.hot.accept("./ContainerErrorsPage.vue?vue&type=template&id=c928455a&", function () {
      api.rerender('c928455a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ContainerErrorsPage.vue"
export default component.exports